/* eslint-disable no-console */
import {MODEL_ENTITY_APP, MODEL_ENTITY_RULE} from '../index'

/**
 * @see WorkflowBlock
 */

export function getBlockModel(
    /**
     * generate 'id' when block is created/copied (with 'block' prefix)
     * some blocks require a specific id (like start and end) to be singleton
     */
    id = false,
    name = '',
    children = [], // cascade svg rendering, order important
    model = {
        entity: MODEL_ENTITY_RULE,
        key: null,
        description: null
    },
    validations = {
        paths: {
            from: {min: 0, max: -1}, // -1 <=> Infinity
            to: {min: 1, max: -1}
        }
    },
    metadata = {
        isChanged: false,
        isEditableModel: true
    },
    x = 0,
    y = 0,
    isHidden = false
) {
    blockModelValidator(model, name)

    return {
        tag: 'svg',
        id,
        name,
        model,
        metadata,
        validations,
        attrs: {x, y},
        editableAttrs: {
            // x: {
            //     label: 'Position X',
            //     type: 'number',
            //     max: Infinity,
            //     min: 0,
            //     step: 10
            // },
            // y: {
            //     label: 'Position Y',
            //     type: 'number',
            //     max: Infinity,
            //     min: 0,
            //     step: 10
            // }
        },
        children,
        isHidden
    }
}

function blockModelValidator(model = {}, blockName) {
    if (!model) {
        console.error('Specify model.', blockName)
    } else {
        if (!model.entity) {
            console.error('Specify model entity.', blockName)
        }
        if (model.entity !== MODEL_ENTITY_APP && !model.key) {
            console.error('Specify model key.', blockName)
        }
        if (!model.description) {
            console.info('Description is missing?', blockName)
        }
    }
}
